import * as React from 'react'
import Header from './header.js'
import Footer from './footer.js';

const Layout = ({ children, location }) =>
{
    return (
        <div className='min-h-screen overflow-hidden flex flex-col text-white'>
            <Header />
            <div className='bg-gradient-to-b from-black to-[#1e1e1e] flex-grow py-10'>
                {/*Keyed by path so the fade replays on every page change*/}
                <div key={location.pathname} className='bg-transparent flex flex-col mx-8 items-center text-center sm:mx-8 md:mx-24 lg:mx-32 xl:mx-40 animate-fade'>
                    {children}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export const wrapPageElement = ({ element, props }) =>
{
    return <Layout {...props}>{element}</Layout>;
};

export default Layout;
